import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface UseAttendanceRealtimeOptions {
  gymId: string;
  enabled?: boolean;
}

export const useAttendanceRealtime = ({
  gymId,
  enabled = true,
}: UseAttendanceRealtimeOptions) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled || !gymId) return;

    const channel = supabase
      .channel(`attendance-realtime-${gymId}`)
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "gym_attendance_logs",
          filter: `gym_id=eq.${gymId}`,
        },
        () => {
          // Invalidate all attendance-related queries for this gym
          queryClient.invalidateQueries({
            queryKey: ["today-attendance-stats", gymId],
          });
          queryClient.invalidateQueries({
            predicate: (query) =>
              query.queryKey[0] === "attendance-logs" &&
              query.queryKey[1] === gymId,
          });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [gymId, enabled, queryClient]);
};
